// extracted by mini-css-extract-plugin
module.exports = {"stickyCartSummary":"CartSummary_stickyCartSummary__A8r0M"};